const footer = $('#footer')
footer.find('.reg_bt').on('click', function () {
  const num = footer.find('.input_number').val()
  let phone =
    num.length > 0 ? `?phone=${footer.find('.input_number').val()}` : ''
  window.open($.getEnv().teacherUrl + phone)
})

//判断正式环境显示百度统计
if ($.getEnv().ENV === 'prod') {
  var _hmt = _hmt || []
  var hm = document.createElement('script')
  hm.src = 'https://hm.baidu.com/hm.js?b4f8f59b22d93e143bec6f3cf289abee'
  var s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(hm, s)
}
